import React, { useEffect, useRef, useState } from "react";
import {
  toastConfig
} from "../../constants/constant";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddButtonDisabled,
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import CommonDialog from "../dialog/CommonDialog";
import ContentLoader from "../loader/ContentLoader";
import styles from "./CustomFieldCategories.module.css";
import { Box } from "@mui/material";
import CustomAutocomplete from "../autocomplete/Autocomplete";
import {
  getAppealCategoryTranslation,
  getChannelTranslation,
  getFundPurposeTranslation,
  getPhilanthropicFundTranslation,
  getProgramTranslation,
  getTranslationsOutput,
} from "../../reduxSlices/translationSlice";
import history from "../../helpers/history";
import { keysHaveValue } from "../../helpers/helper";
import CustomTooltip from "../tooltip/CustomTooltip";
import AddCustomFieldDialog from "../dialog/AddCustomFieldDialog";

const service = new Service();

const CustomFieldCategories = () => {
  const unblockRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openCustomField, setOpenCustomField] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [blockNavOpen, setBlockNavOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState("");
  const [block, setBlock] = useState(true);
  const [loader, setLoader] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [customField, setCustomField] = useState({
    id: "",
    fieldName: "",
  });
  const [formState, setFormState] = useState({
    organizationId: "",
    transalationId: "",
    transType: "",
    translationValue: [
      {
        id: "",
        outputId: "",
        columnValue: "",
        customFieldCategory: "",
      },
    ],
    isTranslationAdded: true,
  });
  const headerData = useSelector((state) => state?.header);
  const buttonAction = headerData?.buttonAction;
  const transalationId = localStorage.getItem("transalationId");
  const transType = localStorage.getItem("transType");
  const selectedOrg = localStorage.getItem("selectedOrg");
  const parseOrg = JSON.parse(selectedOrg);
  const organisationId = parseOrg.organizationId;
  const loading = useSelector((state) => state.translation.loading);
  const respTransType = useSelector(
    (state) => state?.translation?.allChannelTranslation?.data?.transType
  );
  const allTranslationsOutput = useSelector(
    (state) => state?.translation?.allTranslationsOutput
  );
  const allChannelTranslation = useSelector(
    (state) => state?.translation?.allChannelTranslation?.data?.translationValue
  );
  const isTranslationAdded = useSelector(
    (state) => state.translation.isTranslationAdded
  );
  const modifiedData = allChannelTranslation?.map((item, i) => {
    const outputData = allTranslationsOutput.find(
      (e) => e?.outputId === item?.outputId
    );
    const isEmpty = item.outputId <= 0 && isTranslationAdded;
    return { ...item, outputId: outputData ? outputData : 0, isEmpty: isEmpty };
  });
  const isCategoryDisable = isTranslationAdded && transType === respTransType;
  // const customOptions =
  //   transalationId === "2" && transType === "opt2b"
  //     ? campaignCustomOptions
  //     : (transalationId === "7" || transalationId === "8") &&
  //       transType === "opt2"
  //     ? fundCustomOptions
  //     : customFieldOptions;
  const [customOptions, setCustomOptions] = useState([]);
  const page = localStorage.getItem("page");
  const mainTitle = localStorage.getItem("mainTitle");
  const title = localStorage.getItem("title");
  const subTitle = localStorage.getItem("subTitle");
  const placeholder =
    transalationId === "1"
      ? "channel"
      : transalationId === "2"
        ? "program"
        : "appeal";

  useEffect(() => {
    console.log("formStateformState", formState);
  }, [formState]);

  useEffect(() => {
    console.log("customFieldcustomField", customField);
  }, [customField]);

  const handleClose = () => {
    setOpenCustomField(false);
    setDeleteOpen(false);
    setBlockNavOpen(false);
  };

  const handleInputFocus = () => {
    setIsClicked(true);
  };

  const getTranslationsOutputData = async () => {
    const obj = {
      translationId: transalationId || "",
      organisationId: organisationId || "",
    };
    await dispatch(getTranslationsOutput(obj));
  };

  const getChannelTranslationData = async () => {
    const obj = {
      translationId: transalationId || "",
      organisationId: organisationId || "",
      transType: transType || "",
    };
    if (transalationId === "1") {
      await dispatch(getChannelTranslation(obj));
    } else if (transalationId === "2") {
      await dispatch(getProgramTranslation(obj));
    } else if (transalationId === "3") {
      await dispatch(getAppealCategoryTranslation(obj));
    } else if (transalationId === "8") {
      await dispatch(getFundPurposeTranslation(obj));
    } else {
      await dispatch(getPhilanthropicFundTranslation(obj));
    }
  };

  useEffect(() => {
    getTranslationsOutputData();
    getChannelTranslationData();
  }, [dispatch, transalationId, transType]);

  useEffect(() => {
    if (allChannelTranslation) {
      const filteredData = modifiedData?.filter((item) => item?.outputId !== 0);
      const newData = filteredData[0]?.customFieldCategory;
      if (filteredData) {
        setFormState({
          ...formState,
          organizationId: organisationId,
          transalationId: transalationId,
          transType: transType,
          translationValue: [...modifiedData],
        });
      }
      if (newData) {
        setCustomField(
          newData === newData
            ? { id: 1, fieldName: newData }
            : { id: 2, fieldName: newData }
        );
      }
    }
  }, [allChannelTranslation]);

  useEffect(() => {
    if (allChannelTranslation && allChannelTranslation.length > 0) {
      var customOptionsArr = allChannelTranslation.map(e => e.customFieldCategory);
      customOptionsArr = customOptionsArr.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index;
      });
      var cOptions = [];
      customOptionsArr.forEach((item, i) => {
        cOptions.push({ id: i + 1, fieldName: item })
      });
      setCustomOptions(cOptions);
    }
  }, [allChannelTranslation]);

  useEffect(() => {
    if (block) {
      unblockRef.current = history.block((tx) => {
        let url = tx.location.pathname;
        setCurrentPath(url);
        setBlockNavOpen(true);
        return false;
      });
    }
    return () => {
      if (typeof unblock === "function") {
        unblockRef.current && unblockRef.current();
      }
    };
  }, [block]);

  const onConfirmNav = () => {
    if (unblockRef) {
      unblockRef.current();
    }
    setBlockNavOpen(false);
    history.push(currentPath);
  };

  useEffect(() => {
    if (customField?.fieldName) {
      const filteredData = modifiedData?.filter(
        (item) => item?.customFieldCategory === customField?.fieldName
      );
      setFormState({ ...formState, translationValue: [...filteredData] });
    }
  }, [customField?.fieldName]);

  useEffect(() => {
    if (!isClicked) return;
    const keysToCheck = ["outputId"];
    const allKeysHaveValue = formState?.translationValue?.every((obj) =>
      keysHaveValue(obj, keysToCheck)
    );
    console.log("allKeysHaveValue", allKeysHaveValue);
    if (!isTranslationAdded) {
      dispatch(setAddButtonDisabled(allKeysHaveValue));
    } else {
      dispatch(setUpdateButtonDisabled(allKeysHaveValue));
    }
  }, [formState?.translationValue, isClicked]);

  useEffect(() => {
    dispatch(
      setHeader({
        page: page || "",
        mainTitle: mainTitle || "",
        title: title || "",
        subTitle: subTitle || "",
      })
    );
    dispatch(setAddButtonDisabled(false));
    dispatch(setUpdateButtonDisabled(false));
  }, []);

  useEffect(() => {
    if (
      buttonAction.page === "custom-fields-categories" ||
      buttonAction.page === "appeal-custom-categories" ||
      buttonAction.page === "fund-custom-fields" ||
      buttonAction.page === "campaign-custom-categories"
    ) {
      if (buttonAction.action === "add" || buttonAction.action === "update") {
        handleSubmit();
      }
      if (buttonAction.action === "cancel") {
        console.log("tryvhxgfchgvjh");
        handleGoBack();
      }
      if (buttonAction.action === "delete") {
        setDeleteOpen(true);
      }
      if (buttonAction.action === "addCustomField") {
        setOpenCustomField(true);
      }
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = () => {
    createTranslation();
  };

  const handleDelete = () => {
    deleteTranslation();
    setDeleteOpen(false);
  };

  const createTranslation = async () => {
    setLoader(true);
    let url = `/api/Translations/${transalationId === "1"
      ? "AddChannelTranslation"
      : transalationId === "2"
        ? "AddProgramTranslation"
        : transalationId === "3"
          ? "AddAppealCategoryTranslation"
          : transalationId === "8"
            ? "AddFundPurposeTranslation"
            : "AddPhilanthropicFundTranslation"
      }`;
    const user_token = localStorage.getItem("bb_access_token");
    const translationData = prepareTranslationData();
    const formData = JSON.stringify(translationData);
    try {
      let data = await service.newPostApi(url, formData, user_token);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        setIsClicked(false);
        toast.success(`Your data has been recorded`, {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        getChannelTranslationData();
        dispatch(setAddButtonDisabled(false));
        dispatch(setUpdateButtonDisabled(false));
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const deleteTranslation = async () => {
    setLoader(true);
    let url = `/api/Translations/RemoveExistingTranslation?translationId=${transalationId}&organizationId=${organisationId}`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let response = await service.newDeleteApi(url, {}, user_token);
      let resp = response.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        toast.success(`Translation settings has been deleted`, {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        getChannelTranslationData();
        setCustomField({ id: "", fieldName: "" });
        dispatch(setAddButtonDisabled(false));
        dispatch(setUpdateButtonDisabled(false));
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const prepareTranslationData = () => {
    return {
      ...formState,
      translationValue: formState.translationValue?.map(
        ({ isEmpty, ...item }) => {
          return {
            ...item,
            outputId: item?.outputId?.outputId ? item?.outputId?.outputId : 0,
          };
        }
      ),
    };
  };

  const prepareData = prepareTranslationData();

  console.log("prepareTranslationData", prepareData);

  const getOrgLabel = (option) => option?.value;
  const getOrgLabelCustom = (option) => option?.fieldName;
  const getOptionDisabled = (option) => !!option.disabled;

  const handleAutoCompleteChange = (id, value) => {
    const modifiedData = formState?.translationValue?.map((obj) => {
      if (obj.id === id) {
        const isEmpty = value.outputId === 0 && isTranslationAdded;
        return { ...obj, outputId: value, isEmpty: isEmpty };
      }
      return obj;
    });
    setFormState((prevState) => ({
      ...prevState,
      translationValue: [...modifiedData],
    }));
  };

  const handleAutoCompleteChangeCustom = (name, value) => {
    setCustomField({ ...value });
  };

  if (loading || loader) return <ContentLoader />;

  return (
    <>
      <Box
        component="form"
        sx={{
          "& > :not(style)": { marginBottom: "40px", width: "520px" },
        }}
        noValidate
        autoComplete="off"
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <label style={labelStyle}>
            Category<sup style={requiredAr}>*</sup>
          </label>
          <CustomTooltip
            title={
              isCategoryDisable
                ? "To use this option, please delete your existing translation settings."
                : ""
            }
            placement="bottom"
          >
            <Box>
              <CustomAutocomplete
                options={customOptions}
                value={customField}
                disabled={isCategoryDisable}
                onChange={(e, value) => {
                  if (value === null) {
                    value = {
                      id: "",
                      fieldName: "",
                    };
                  }
                  handleAutoCompleteChangeCustom("customField", value);
                }}
                getOptionLabel={getOrgLabelCustom}
                getOptionDisabled={getOptionDisabled}
                placeholder="Select a custom field category..."
              />
            </Box>
          </CustomTooltip>
        </Box>
      </Box>
      {customField.fieldName &&
        formState?.translationValue &&
        formState?.translationValue?.map((item, i) => (
          <Box
            key={i}
            className={`${styles.mainContainer} ${item?.isEmpty ? styles.emptyfield : ""
              }`}
          >
            <Box className={styles.container}>
              <Box className={styles.contentDiv}>{item?.columnValue}</Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "520px",
              }}
            >
              <CustomAutocomplete
                options={allTranslationsOutput}
                value={item?.outputId}
                onChange={(e, value) => {
                  if (value === null) {
                    value = {
                      outputId: 0,
                      value: "",
                    };
                  }
                  handleAutoCompleteChange(item?.id, value);
                }}
                getOptionLabel={getOrgLabel}
                onFocus={handleInputFocus}
                placeholder={`Select the ${placeholder} for the corresponding category...`}
              />
            </Box>
          </Box>
        ))}

      <CommonDialog
        open={blockNavOpen}
        setOpen={setBlockNavOpen}
        handleCancel={handleClose}
        handleDone={onConfirmNav}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
      <CommonDialog
        open={deleteOpen}
        setOpen={setDeleteOpen}
        handleCancel={handleClose}
        handleDone={handleDelete}
        title="Confirm delete"
        subTitle="Are you sure you want to delete these settings? You’ll not be able to reverse this action."
        leftButtonText="Cancel"
        rightButtonText="Delete"
      />
      <AddCustomFieldDialog
        open={openCustomField}
        setOpen={setOpenCustomField}
        handleDone={handleClose}
        title="Add Organisation Specific Program"
        leftButtonText="Cancel"
        rightButtonText="Submit"
        getTranslationsOutputData={getTranslationsOutputData}
      />
    </>
  );
};

export default CustomFieldCategories;

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};
